/**
 * QueryError
 *
 * Aviso para cuando una consulta falla. Sin él, una lista que no cargó se ve
 * igual que una lista vacía y el usuario cree que no hay datos.
 */

import { AlertTriangle, RefreshCw } from 'lucide-react'

import { t } from '@/i18n'
import { Button } from '@/components/ui/button'

interface QueryErrorProps {
  message?: string
  onRetry?: () => void
}

export function QueryError({ message, onRetry }: QueryErrorProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-3 rounded-lg border border-destructive/40 bg-destructive/5 p-6 text-center"
    >
      <AlertTriangle className="h-6 w-6 text-destructive" aria-hidden="true" />
      <p className="text-sm text-foreground">{message ?? t('common.loadFailed')}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          <RefreshCw className="mr-2 h-4 w-4" aria-hidden="true" />
          {t('common.retry')}
        </Button>
      )}
    </div>
  )
}
